import { InviteMembers } from '@/features/invites/components/invite-members';
import { MembershipRole } from '@/types/api/membership';
import { OnboardingTaskKey } from '@/types/api/group/onboarding-task';
import { onboardingMutationKey } from '../../hooks/use-onboarding-progress';

export function InviteMembersTask({ groupId }: { groupId: string }) {
  return (
    <div className="space-y-4">
      <p className="text-sm">
        Deltagarna får en länk där de skapar ett konto och går med i gruppen. Du kan bjuda in fler när som helst under
        Gruppmedlemmar.
      </p>
      <InviteMembers
        roles={[MembershipRole.Member]}
        orgId={groupId}
        // A created invite link completes the task
        mutationKey={onboardingMutationKey(groupId, OnboardingTaskKey.InviteMembers)}
      />
    </div>
  );
}
